import { COLOR_PROFILE_VALUES } from '@rendering/types';
import { toSelectOption } from 'src/util/misc';

export const DEFAULT = 'Use Default';
export const FINISHES = 'Finishes';
export const BLENDING_MODE = 'Blending Mode';
export const PRODUCT_OPTION = 'Product Option';
export const COLOR_PROFILE = 'Color Profile';

export const ASSET_ACTIONS = {
    REPLACE: 'REPLACE',
    FILL: 'FILL',
    REMOVE: 'REMOVE',
} as const;
export const ASSET_ACTIONS_OPTIONS = toSelectOption(['REPLACE', 'FILL', 'REMOVE']);

export const DOCUMENT_ACTIONS = {
    BLENDING_MODE: 'blendingMode',
    FINISHES: 'finish',
    COLOR_PROFILE: 'colorProfile',
} as const;

export const PURPOSES_OPTIONS = [
    { label: 'Product Full', value: 'Product:Full' },
    { label: 'Product Closeup', value: 'Product:Closeup' },
    { label: 'Product Alternate', value: 'Product:Alternate' },
    { label: 'Design Overlay', value: 'Design:Overlay' },
    { label: 'Design Underlay', value: 'Design:Underlay' },
];

export const MERCHANDISING = {
    value: 'Merchandising',
    label: 'Merchandising',
};

export const SCENE_VARIABLE_TYPES = {
    'Asset Change': 'Asset Change',
    Cropping: 'Cropping',
} as const;
export const SCENE_VARIABLE_TYPES_OPTIONS = toSelectOption(['Asset Change', 'Cropping']);

export const PRODUCT_VARIABLE_TYPES = {
    product: PRODUCT_OPTION as string,
    blending: BLENDING_MODE as string,
    finishes: FINISHES as string,
    colorProfile: COLOR_PROFILE as string,
} as const;
export const PRODUCT_VARIABLE_TYPES_OPTIONS = toSelectOption([PRODUCT_OPTION, BLENDING_MODE, FINISHES, COLOR_PROFILE]);

export const BLENDING_MODES = {
    Normal: 'Normal',
    Multiple: 'Multiply',
} as const;
export const BLENDING_MODES_OPTIONS = toSelectOption(['Normal', 'Multiply']);

// Per-attribute-value color profile override for variable scenes. 'Use Default' means
// "don't override — keep this document's own statically-configured color profile",
// mirroring how the Scenes Service treats a missing `colorProfile` field (operation: 'none').
export const COLOR_PROFILE_OPTIONS = [
    { value: DEFAULT, label: DEFAULT },
    ...COLOR_PROFILE_VALUES.map((value) => ({ value, label: value })),
];

export const SURFACE_ACTIONS = {
    INCREMENT: 'INCREMENT',
    DECREMENT: 'DECREMENT',
    REPLACE: 'REPLACE',
} as const;
